"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSetAggregationData = void 0;
const enums_1 = require("../../sales-order/enums");
const responses_1 = require("../../sales-order/responses");
const models_1 = require("../models");
const packaging_set_line_data_response_1 = require("./packaging-set-line-data.response");
class PackagingSetAggregationData {
}
exports.PackagingSetAggregationData = PackagingSetAggregationData;
//# sourceMappingURL=packaging-set-aggregation-data.response.js.map